
import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface DialogData {
  value: number;
  titulo: string;
  descr: string;
  success_class: string;
  success_text: string;
}

/**
 * Pop Up Prompt
 */
@Component({
  selector: 'confirmdialog',
  templateUrl: './confirmdialog.html',
})
export class ConfirmDialog {
  
  constructor(
    public dialogRef: MatDialogRef<ConfirmDialog>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) {
    if (!this.data.success_class){
      this.data.success_class = 'primary';
    }
    if (!this.data.success_text){
      this.data.success_text = 'OK';
    }
  }

}